import { useEffect, useState } from 'react';
import axios from 'axios';

const cache = {};
// Regions/provinces for a country code, fetched once from the backend (empty list when unknown).
export const useRegions = (country) => {
  const [regions, setRegions] = useState(cache[country] || []);
  useEffect(() => {
    if (!country || country === 'all') { setRegions([]); return; }
    if (cache[country]) { setRegions(cache[country]); return; }
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/geo/regions/${country}`)
      .then((r) => { cache[country] = r.data.regions || []; setRegions(cache[country]); })
      .catch(() => setRegions([]));
  }, [country]);
  return regions;
};
